import { Image } from '@/components'
import { getVND } from '@/utils/helpers'
import { Box, Stack, TableCell, TableRow, Typography } from '@mui/material'
import Link from 'next/link'
import { Fragment } from 'react'

type Props = { product: IOrderProduct }

export const ProductItemInTable = ({ product }: Props) => {
  return (
    <Fragment>
      {/* Desktop View - Table Row (hiển thị từ md trở lên) */}
      <TableRow
        sx={{
          '&:not(:last-child)': { borderBottom: '1px solid', borderColor: 'bd.main' },
          '& td': {
            p: {
              xs: '.3em .6em',
              md: 1,
            },
            border: 'none',
          },
          flexDirection: 'column',
          position: 'relative',
          display: {
            xs: 'flex',
            md: 'table-row',
          },
        }}
      >
        {/* Product Info Cell */}
        <TableCell width={'0%'} data-label={'Sản phẩm'}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Link href={`/products/${product?.product_url_key}`} style={{ display: 'flex' }}>
              <Image
                src={product?.product_image}
                alt={product?.product_name}
                style={{ aspectRatio: '1 / 1', width: 72, objectFit: 'cover', borderRadius: '8px' }}
              />
            </Link>
            <Stack
              sx={{
                pr: {
                  xs: '1em',
                  md: 0,
                },
              }}
            >
              <Link href={`/products/${product?.product_url_key}`}>
                <Typography
                  sx={{
                    fontSize: {
                      xs: '0.75rem',
                      md: '0.875rem',
                    },

                    fontWeight: 500,
                    '&:hover': { color: 'four.main' },
                  }}
                >
                  {product?.product_name}
                </Typography>
              </Link>
              <Typography
                sx={{
                  fontSize: {
                    xs: '0.675rem',
                    md: '0.75rem',
                  },
                }}
              >
                x{product?.quantity_ordered},{' '}
                {product?.selected_options.map((option) => option.value).join(', ')}
              </Typography>
            </Stack>
          </Box>
        </TableCell>

        {/* Price Cell */}
        <TableCell
          align="right"
          data-label={'Giá'}
          sx={{
            display: {
              xs: 'flex',
              md: 'table-cell',
            },
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: { xs: 'space-between', md: 'flex-start' },
            '&:before': {
              content: `'Giá:'`,
              display: { xs: 'inline-block', md: 'none' },
              fontSize: '1em',
              color: '#7b7b7b',
            },
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: '0.875rem',
                md: '1rem',
              },
              lineHeight: 1.3,
              fontWeight: 600,
            }}
          >
            {getVND(product?.product_sale_price?.value, 'Đ')}
          </Typography>
        </TableCell>
      </TableRow>
    </Fragment>
  )
}
